import * as React from "react"
import Layout from "../components/layout/layout";
import GoogleMap from "../components/common/google-map";
import SubPageTitle from "../components/common/sub-page-title";
import ContactBox from "../components/common/contact-box";
import expertImg from "../images/podolog-ilona-olszewska.jpg";
import Info from "../data/data";
import * as contactStyle from "./kontakt.module.scss";
import Seo from "../data/seo"

const ContactPage = () => {
    return (
        <Layout seo={Seo.kontakt}>
            <SubPageTitle title="Kontakt"></SubPageTitle>
            <div className="container pb-5">
                <div className="row justify-content-center">
                    <div className="row align-items-md-stretch pb-5">
                        <div className="col-md-6">
                            <div className={contactStyle.contactBox + ' mx-auto'}>
                                <ContactBox></ContactBox>
                            </div>
                        </div>
                        <div className="col-md-6 text-center">
                            <img className="img-fluid" src={expertImg} alt={Info.expert} />
                        </div>
                    </div>
                    <GoogleMap height="600"></GoogleMap>
                </div>


            </div>
        </Layout>
    )
}

export default ContactPage